import React, { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE, API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_jupiter";
import useHttp from "../../../hook/use-http";
import Filter_Jupiter from "./Filter";
// Old gauge-based detail screen (Vehicle Details / Indicator Lamp / SOC / Speedometer / Distance to Empty)
// replaced by VehicleStateCard_Jupiter, which consumes the CVP get-vehicle-state-details-for-dic API.
// import VehicleDetails_Jupiter from "./VehicleDetails";
// import IndicatorLamp_Jupiter from "./IndicatorLamp";
// import DefLevel_Jupiter from "./DefLevel";
// import Speedometer_Jupiter from "./Speedometer";
// import DistanceToEmpty_Jupiter from "./DistanceToEmpty";
import VehicleStateCard_Jupiter from "./VehicleStateCard";
import DashboardMain_Jupiter from "../DashboardMain_Jupiter/DashboardMain_Jupiter";
// import "./DigitalInstrumentalCluster.css";
import WaterMark from "../DashboardMain_Jupiter/WaterMark";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import styles from './DigitalInstrumentalCluster.module.css'
import { BsSticky } from "react-icons/bs";
import TopBottomPerformingVehicles_Jupiter from "./TopBottomPerformingVehicles";
import FilterSecondPage_Jupiter from "./FilterSecondPage";
import TopKpiCards_Jupiter from "./TopKpiCards";
import VehicleOperations_Jupiter from "./VehicleOperations";
import DICPopup_Jupiter from "./DICPopup";

function RealTImeFaultCode_Jupiter() {
  const [gloablfilter, setGloablfilter] = useState({
    ...INIT_FILTER_STATE,
    pageSelected: 1,
    VIN_NUM: [], // or provide a default VIN if needed
  });
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [modalData, setModalData] = useState({ title: "", data: [] })

  const log_data = (data) => { };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "digital_instrument_cluster_Jupiter",
        },
      },
      log_data
    );
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter({ ...data });
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => {
      return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 };
    });
  };

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] };
    });
  };

  const onreset = (data) => {
    setGloablfilter(data);
  };

  const loggedInUser = useSelector(selectLoggedInUser);

  const cards = [{ cNm: 'Total / Active Vehicles', cCnt: '4566/2500', imgNm: 'tot_act_v', apiEnd: '' },
  { cNm: 'Total Vehicles with Fault', cCnt: '1800', imgNm: 'tot_veh_f', apiEnd: 'tot_veh_fault_count' },
  { cNm: 'Vehicles with BMS Fault', cCnt: '500', imgNm: 'v_BMS_f', apiEnd: 'BMS_fault_count' },
  { cNm: 'Vehicles with DCDC Fault', cCnt: '300', imgNm: 'v_DCDC_f', apiEnd: 'DCDC_fault_count' },
  { cNm: 'Vehicles with MCU Fault', cCnt: '200', imgNm: 'v_MCU_f', apiEnd: 'MCU_fault_count' },
  { cNm: 'Vehicles with OBC Fault', cCnt: '550', imgNm: 'v_OBC_f', apiEnd: 'OBC_fault_count' },
  { cNm: 'Vehicles with BCS Fault', cCnt: '250', imgNm: 'v_BCS_f', apiEnd: 'BCS_fault_count' }]

  const oneCard = [{ cNm: 'Driving', apiEnd: 'driving' }, { cNm: 'Idling', apiEnd: 'idling' }, { cNm: 'Charging', apiEnd: 'charging' }, { cNm: 'Offline', apiEnd: 'offline' }, { cNm: 'Data Pack Expired', apiEnd: 'data_pack_expired' }]

  const tabTemp = [
    { Tabtitle: 'Fault ECU VINs', tabCol1: 'Vins', tabCol2: 'Count', apiEnd: 'faulty_ECU_vehicles' },
    { Tabtitle: 'Lowest SOC VINs', tabCol1: 'Vins', tabCol2: 'Value', apiEnd: 'lowest_SOC_vehicles' },
    { Tabtitle: 'Highest Motor Temp VINs', tabCol1: 'Vins', tabCol2: 'Temp', apiEnd: 'motor_temp_vehicles' },
    { Tabtitle: 'Highest Battery Temp VINs', tabCol1: 'Vins', tabCol2: 'Temp', apiEnd: 'battery_temp_vehicles' }
  ]

  const getModalData = (ele) => {
    fetchData(
      {
        url: API_URL_MAIN + `jupiter_dic/${ele.apiEnd}_tableData`,
        body: { filterdata: gloablfilter },
      },
      (data) => {
        setModalData(prev => ({
          ...prev,
          title: ele?.cNm,
          data: data,
        }))
      }
    );
  }


  if (gloablfilter.pageSelected === 1) {
    return (
      <>
        <DashboardMain_Jupiter>
          <div className="new_drive_dashboardDIC pt-1">
            <Filter_Jupiter onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
            <div className="container-fluid pb-3">
              <div className="row row-cols-2 justify-content-between">
                {cards.map((ele, i) => (
                  // <>
                  //   <div class={`col mb-3 ${(i != 0) ? styles.pl0Important : ''}`}>
                  //     <TopKpiCards cardsData={ele} gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                  //   </div>
                  // </>
                  <>
                    <div class={`col mb-3 ${(i != 0) ? `${styles.pl0Important} hand_geture` : ''}`} data-toggle={`${i > 0 ? "modal" : ""}`} data-target={`${i > 0 ? "#myModal_jupiter" : ""}`} onClick={() => { if (i > 0) { getModalData(ele) } }}>
                      <TopKpiCards_Jupiter cardsData={ele} gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                    </div>
                  </>
                ))
                }
              </div>

              <div className="row">
                <div className="mb-3">
                  <div className={`${styles.kipBoxes} d-flex flex-wrap col-12 p-0`}>
                    <div className={`ps-2 col-12 col-md ${styles.KPI_left_right_card} d-flex justify-content-center align-items-center`}>
                      <p className="m-0">
                        <span className="fs-6 font-weight-bold text-white">Vehicles</span>
                      </p>
                    </div>

                    {oneCard.map((ele, i) => (
                      <div key={i} className={`ps-2 col-12 col-md ${(i !== 4) ? styles.forBetweenBorder : ''} d-flex flex-column align-items-start`}>
                        <VehicleOperations_Jupiter oneCard={ele} gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                      </div>
                    ))}

                    <div className={`ps-2 col-12 col-md ${styles.KPI_right_left_Card} d-flex justify-content-center align-items-center`}>
                      <p className="m-0">
                        <span className="fs-6 font-weight-bold text-white">Operations</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="mb-3">
                  <div className={`${styles.kipBoxes} d-flex justify-content-center align-items-center`}>
                    <h5 className={`text-start mt-2 ${styles.textColorGreen} ${styles.fw_600}`}>
                      Top/Bottom Performing Vehicles
                    </h5>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* <div className="mb-3 d-flex col-12 px-0"> */}
                {tabTemp.map((ele, i) => (
                  <div className={`col-md-3 ${(i !== 0) ? styles.pl0Important : ''}`}>
                    <TopBottomPerformingVehicles_Jupiter tableData={ele} gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                  </div>
                ))}
                {/* </div> */}
              </div>
            </div>
          </div>
          <DICPopup_Jupiter data={modalData} singleVinSelected={singleVinSelected} />
        </DashboardMain_Jupiter>
      </>
    );
  } else {
    return (
      <DashboardMain_Jupiter gloablfilter={gloablfilter}>
        <div className="new_drive_dashboardDIC">
          <FilterSecondPage_Jupiter onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} pageChange={pageChange} />
          {/* <Filter onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} /> */}
          {(gloablfilter.VIN_NUM?.length > 0) ?
            <div className="container-fluid">
              <div className="row">
                <div className="col-12" >
                  <div className="row mb-3 equal-cols">
                    <div className="col-12 borderDownDIC">
                      <WaterMark />
                      <VehicleStateCard_Jupiter gloablfilter={gloablfilter} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : <img src={`/assets/images_realTimeFaultCode/no_real_time_data.png`} width="33%" />
          }
        </div>
      </DashboardMain_Jupiter>
    );
  }
}

export default RealTImeFaultCode_Jupiter;